(function initCharacterShare() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.__characterShareReady) return;
  window.__characterShareReady = true;

  function currentCharacter(button) {
    return (
      (window.fixtures && window.fixtures.currentAI) || {
        name: button ? button.dataset.character : '',
        url_name: button ? button.dataset.urlName : '',
      }
    );
  }

  function currentRoom() {
    var f = window.fixtures || {};
    if (f.room_name) {
      return { name: String(f.room_name), key: f.room_key ? String(f.room_key) : '' };
    }
    if (window.location.pathname.indexOf('/r/') === 0) {
      var slug = decodeURIComponent(window.location.pathname.slice(3).split('/')[0]);
      return { name: slug.replace(/-/g, ' '), key: slug };
    }
    return null;
  }

  function roomURL(room) {
    if (window.location.pathname.indexOf('/r/') === 0) {
      return new URL(window.location.pathname, window.location.origin).href;
    }
    var slug = room.key || room.name.trim().replace(/\s+/g, '-').toLowerCase();
    return new URL('/r/' + encodeURIComponent(slug), window.location.origin).href;
  }

  function characterURL(character) {
    var slug = character && character.url_name;
    if (slug) {
      return new URL('/ai-chat/' + encodeURIComponent(slug), window.location.origin).href;
    }
    if (window.location.pathname.indexOf('/ai-chat/') === 0) {
      return new URL(window.location.pathname, window.location.origin).href;
    }
    var name = character && character.name ? character.name.trim() : '';
    var fallback = name.replace(/\s+/g, '-');
    return new URL('/ai-chat/' + encodeURIComponent(fallback), window.location.origin).href;
  }

  function copyText(input) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(input.value);
    }
    input.focus();
    input.select();
    if (!document.execCommand('copy')) {
      return Promise.reject(new Error('Copy failed'));
    }
    return Promise.resolve();
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest && event.target.closest('#character-share-btn');
    if (openButton) {
      var dialog = document.getElementById('character-share-dialog');
      var input = document.getElementById('character-share-url');
      var name = document.getElementById('character-share-name');
      if (!dialog || !input) return;
      var title = document.getElementById('character-share-dialog-title');
      var label = dialog.querySelector('label[for="character-share-url"]');
      var room = currentRoom();
      if (room) {
        input.value = roomURL(room);
        if (name) name.textContent = room.name || 'Room';
        if (title) title.textContent = 'Share room';
        if (label) label.textContent = 'Room link';
      } else {
        var character = currentCharacter(openButton);
        input.value = characterURL(character);
        if (name) name.textContent = character.name || 'Character';
        if (title) title.textContent = 'Share character';
        if (label) label.textContent = 'Character link';
      }
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', 'open');
      input.focus();
      input.select();
      return;
    }

    var closeButton = event.target.closest && event.target.closest('.character-share-close');
    if (closeButton) {
      var closeDialog = closeButton.closest('dialog');
      if (closeDialog && typeof closeDialog.close === 'function') closeDialog.close();
      else if (closeDialog) closeDialog.removeAttribute('open');
      return;
    }

    var copyButton = event.target.closest && event.target.closest('#character-share-copy');
    if (!copyButton) return;
    var copyInput = document.getElementById('character-share-url');
    if (!copyInput) return;
    copyText(copyInput)
      .then(function () {
        copyButton.textContent = 'Copied';
        window.setTimeout(function () {
          copyButton.textContent = 'Copy link';
        }, 1500);
      })
      .catch(function () {
        copyInput.focus();
        copyInput.select();
      });
  });
})();
